var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHayomyom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142 648 c-7 -7 -12 -22 -12 -35 0 -23 0 -23 300 -23 290 0 300 1 300 19 0 19 -24 51 -39 51 -4 0 -13 -11 -19 -25 -21 -45 -112 -37 -112 10 0 25 -257 22 -264 -3 -16 -49 -101 -50 -113 -2 -6 23 -23 26 -41 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 523 c-68 -4 -68 -4 -68 -198 0 -248 -24 -226 256 -223 209 3 209 3 212 44 4 52 25 72 82 76 45 3 45 3 48 151 l3 147 -138 0 c-76 0 -181 2 -233 4 -52 2 -125 2 -162 -1z m462 -142 c12 -23 14 -88 3 -94 -5 -3 -34 -2 -65 0 -58 5 -58 5 -58 53 0 58 2 60 61 60 38 0 51 -4 59 -19z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 705 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45 -5 0 -10 -20 -10 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 699 c0 -31 4 -48 10 -44 6 3 10 26 10 51 0 24 -4 44 -10 44 -5 0 -10 -23 -10 -51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 652 c-10 -10 -17 -31 -17 -45 0 -27 0 -27 305 -27 336 0 337 0 304 59 -20 36 -55 40 -63 7 -4 -18 -16 -28 -39 -35 -25 -7 -27 -9 -9 -10 22 -1 62 30 62 49 0 6 4 10 9 10 16 0 41 -31 41 -51 0 -18 -10 -19 -300 -19 -300 0 -300 0 -300 23 0 42 43 65 53 27 12 -48 97 -47 113 2 7 24 264 28 264 4 0 -7 8 -20 18 -27 14 -11 15 -11 5 1 -7 8 -13 22 -13 32 0 16 -12 18 -140 18 -111 0 -140 -3 -140 -13 0 -49 -84 -59 -96 -12 -7 30 -34 33 -57 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 385 c0 -137 2 -195 3 -128 2 67 2 179 0 250 -1 70 -3 16 -3 -122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 333 c0 -109 4 -203 8 -209 19 -29 56 -34 254 -34 225 0 228 1 228 61 0 46 13 57 75 61 50 3 50 3 53 161 l3 157 -178 -2 -178 -2 173 -3 173 -3 -3 -148 c-3 -147 -3 -147 -48 -150 -57 -4 -78 -24 -82 -76 -3 -41 -3 -41 -212 -44 -280 -3 -256 -25 -256 223 0 194 0 194 68 198 67 3 67 3 -5 5 l-73 2 0 -197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 393 c-4 -3 -7 -28 -7 -53 0 -48 0 -48 58 -53 70 -6 72 -4 72 39 0 59 -14 74 -69 74 -26 0 -51 -3 -54 -7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560 732 c0 -9 -39 -13 -132 -14 l-133 -2 129 -3 c120 -3 163 4 143 24 -4 3 -7 1 -7 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 673 c37 -2 97 -2 135 0 37 2 6 3 -68 3 -74 0 -105 -1 -67 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 527 c-2 -7 -3 -98 -1 -202 l2 -190 3 197 2 197 98 4 97 3 -98 2 c-72 1 -99 -1 -103 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 533 c57 -2 147 -2 200 0 53 1 7 3 -103 3 -110 0 -154 -2 -97 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652 133 c4 -44 28 -55 59 -27 37 34 20 64 -37 64 -23 0 -25 -3 -22 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 43 c73 -2 193 -2 265 0 73 1 14 3 -132 3 -146 0 -205 -2 -133 -3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 768 c-5 -13 -12 -31 -15 -40 -3 -11 -15 -18 -29 -18 -13 0 -36 -14 -53 -31 -29 -30 -29 -30 -32 -272 -5 -379 -27 -357 351 -357 383 0 359 -24 355 351 -3 261 -3 261 -31 285 -15 13 -39 24 -53 24 -16 0 -24 6 -24 18 0 65 -77 83 -96 22 -12 -35 -12 -35 -139 -38 -136 -3 -155 3 -155 43 0 40 -65 50 -79 13z m49 -63 c0 -42 -3 -55 -15 -55 -16 0 -23 89 -8 103 16 17 23 3 23 -48z m380 -6 c0 -37 -4 -49 -15 -49 -15 0 -23 89 -9 103 15 14 24 -7 24 -54z m-429 -56 c11 -30 56 -29 73 2 18 33 26 35 159 35 126 0 128 0 137 -24 19 -52 85 -54 92 -4 7 51 78 12 78 -43 0 -26 0 -26 -227 -31 -404 -7 -428 -3 -392 63 22 42 64 43 80 2z m539 -268 c0 -165 0 -165 -48 -165 -59 0 -79 -18 -84 -75 -3 -40 -3 -40 -230 -43 -291 -3 -268 -24 -268 243 0 105 3 195 7 198 3 4 145 7 315 7 l308 0 0 -165z m-26 -211 c22 -8 20 -37 -3 -58 -31 -28 -55 -17 -59 27 -3 39 16 49 62 31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHayomyom);
export default __webpack_public_path__ + "static/media/hayomyom.f4b744c39c5b7ca3230600af16d75604.svg";
export { ForwardRef as ReactComponent };